// extracted by mini-css-extract-plugin
export default {"wrapper":"SecondStep_wrapper__iEMPF","wrapper__title":"SecondStep_wrapper__title__mP-hM","wrapper__add-stop-button":"SecondStep_wrapper__add-stop-button__y+Prb"};